import React from 'react';

function Menu() {
  return (
    <>
      <div className="side_menu4_overlay"></div>
      <div className="side_menu4_overlay2"></div>
      <div className="side_menu_style4">
        <div className="content">
          <div className="main_links">
            <ul>
              <li>
                <a href="#home" className="main_link">
                  Начало
                </a>
              </li>
              <li>
                <a href="#projects" className="main_link">
                  Проекти
                </a>
              </li>
              <li>
                <a href="#buy" className="main_link">
                  Закупуване
                </a>
              </li>
              <li>
                <a href="#about" className="main_link">
                  За нас
                </a>
              </li>
              <li>
                <a href="#contacts" className="main_link">
                  Контакти
                </a>
              </li>
            </ul>
          </div>
        </div>
        <img
          src="/home1/assets/img/chat_pat2.png"
          alt="asset"
          className="side_shape"
        />
        <img
          src="/home1/assets/img/chat_pat2.png"
          alt="asset"
          className="side_shape2"
        />
        <span className="clss" aria-label="Затвори менюто">
          <i className="la la-times"></i>
        </span>
      </div>
    </>
  );
}

export default Menu;
